export default __webpack_public_path__ + "website-contact.svg";